<div class="container-fluid">
  <div class="row ">
    <div class="col-4 p-3">
      <!-- {{ user.first_name }} {{ user.last_name }} -->
      <h3 class="font-weight-bold">{{ user.first_name }} {{ user.last_name }}</h3>
      <h6 class="font-weight-bold text-black-50">{{ user.designation.designation_name }}</h6>
      <!-- {{ user.designation.designation_name }} -->
    </div>
    <div class="col-2 mt-4   text-white text-center apply2">
      <!-- <a [routerLink]="['/home', 'applyleaves']" class="btn btn-secondary bg-secondary"><i class="icon-plus"></i>  Apply Leave</a> -->
    </div>
    <div class="col mt-2 text-white text-center space working-attend">
      <span class="font-weight-bold">Available Leaves</span>
      <h3 class="font-weight-bold mt-4">{{ (stats[0] == null) ? '21' : stats[0].available_leaves }}</h3>
    </div>
    <div class="col mt-2 text-white text-center space worked-attend">
      <span class="font-weight-bold">Leaves</span>
      <h3 class="font-weight-bold mt-4">{{ (stats[0] == null) ? '0': stats[0].leaves_this_month }}</h3>
    </div>
    <div class="col mt-2 text-white text-center space overtime">
      <span class="font-weight-bold">Absent</span>
      <h3 class="font-weight-bold mt-4">{{ (absent === '') ? '0' : absent }}</h3>
    </div>
    <div class="col mt-2 text-white text-center  missing-check space">
      <span class="font-weight-bold">Renew Date</span>
      <h3 class="font-weight-bold text-center mt-4">1st Aug 21</h3>
    </div>
  </div>







  <div class="row mt-3">
    <div class="col-xl-8 col-sm-6 col-12 ">
      <div class="card shadow">
        <!-- #f="ngForm" (ngSubmit)="onSubmit(f)" -->
        <form>
          <div class="card-content ">
            <!-- <h4 class="p-1 mt-2 ml-4 text-secondary font-weight-bold  weekly-graph">Filter</h4> -->
            <a href=" " class="btn btn status-btn mt-2 ml-2"
              style="background-color: {{ getLeaveColor(data.status) }};text-transform: capitalize;">{{ data.status
              }}</a>
            @if (data.monthly_sequence > 2) {
              <span class="ml-2 mt-2 d-inline-block"
                style="background:#e53e3e;color:#fff;padding:4px 10px;border-radius:12px;font-size:12px;vertical-align:middle;">
                {{ data.monthly_sequence }}{{ data.monthly_sequence === 3 ? 'rd' : data.monthly_sequence === 2 ? 'nd' : 'th' }} Request
              </span>
            }
            <div class="card-body ">
              <div class="media d-flex text-secondary-light mb-5 time-detail">
                <div class="col-6">
                  <span class="text-secondary start-date">Title</span>
                  <input type="text" name="title" id="title" class="form-control" value="{{ data.title }}"
                    [readonly]="true">
                </div>
                <div class="col-6">
                  <span class="text-secondary  start-date">Leave Type</span>
                  <select id="leave_type_id" name="leave_type_id" data-toggle="dropdown"
                    class=" dropdown-toggle checks-dropdown  form-control" value="{{ data.type.id }}">
                    <option value="1">Half Leave</option>
                    <option value="2">Short Leave</option>
                    <option value="3">Full Leave</option>
                  </select>
                </div>
              </div>


              <div class="media d-flex text-secondary-light mb-5 time-detail">
                <div class="col-6">
                  <span class="text-secondary  start-date">Start Date</span>
                  <input type='date' name="start_date" id="start_date" class="form-control date-type"
                    id='datetimepicker4' value="{{ data.start_date }}" [readonly]="true" />
                </div>
                <div class="col-6">
                  <span class="text-secondary end-date">End Date</span>
                  <input type="date" name="end_date" id="end_date" class="form-control date-type"
                    value="{{ data.end_date }}" [readonly]="true">
                </div>
              </div>


              <!-- <div class="media d-flex text-secondary-light mb-5 time-detail">
                                <div class="col-6">
                                    <span class="text-secondary  start-date">Start Time</span>
                                    <input type="time" name="start_time" id="start_time" class="form-control" value="{{ data.start_date }}" />
                                </div>
                                <div class="col-6">
                                    <span class="text-secondary end-date">End Time</span>
                                    <input type="time" name="end_time" id="end_time" class="form-control" value="{{ data.end_date }}">
                                </div>
                            </div> -->

              <div class="media d-flex text-secondary-light mb-5  time-detail">
                <div class="col-6">
                  <span class="text-secondary  start-date">Paid/Unpaid</span>
                  <select id="leave_payment_status" name="leave_payment_status" class="checks-dropdown form-control"
                    value="{{ data.leave_payment_status }}">
                    <option value="paid">Paid Leave</option>
                    <option value="unpaid">Unpaid Leave</option>
                  </select>
                </div>
                <div class="col-6">

                </div>
              </div>

              <div class="media d-flex text-secondary-light mb-5">
                <div class="col description">
                  <h6>Descripton</h6>
                  <p>
                    {{ data.description }}
                  </p>
                </div>
              </div>

              <!-- <div class="media d-flex text-secondary-light mb-5  time-detail">
                                <div class="col-6">
                                    <button class="btn btn float-right cancel">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button type="submit" class="btn btn apply">Apply</button>
                                </div>
                            </div> -->




            </div>
          </div>
        </form>
      </div>
      <!-- <app-loader *ngIf="showSpinner">
            </app-loader> -->
    </div>






    <div class="col-xl-4 col-sm-6 col-12 ">
      <!-- <div class="card">
                <div class="card-content rounded">
                    <a href=" " class="btn btn text-white   ml-2 mt-3 approved1">Approved</a>
                    <div class="card-body ">
                        <div class="media d-flex text-center font-weight-bold  text-secondary" style="font-size: 14px;">

                        </div>

                        <div class="media d-flex text-center text-secondary-light font-weight-bolder time-detail">

                        </div>

                    </div>
                </div>
            </div> -->
      <div class="container">
        <div class="row">
          <div class="pr-3 pb-3">
            <bs-datepicker-inline [bsValue]="bsInlineValue"
              [bsConfig]="{ containerClass: 'theme-dark-blue', todayPosition: 'center' }"></bs-datepicker-inline>
          </div>
        </div>
      </div>



    </div>



  </div>





</div>